import HandsontableHelper from "@/helpers/settings/handsontable";

const ContextMenu = (instance) => {
  {
    return {
      items: {
        title: {
          name: "Menu:",
          renderer: HandsontableHelper.contextMenuTitleRenderer,
          disableSelection: true, // Prevent mouseoever from highlighting the item for selection
          isCommand: true // Prevent clicks from executing command and closing the menu
        },
        set_password: {
          name: "<div class='flex'><i class='fas fa-key text-orange-500 mr-1 mt-1'></i><div>Change password</div></div>",
          renderer: HandsontableHelper.contextMenuRenderer,
          callback: instance.changePassword
        },
        delete_user: {
          name: "<div class='flex'><i class='fas fa-trash-alt text-red-500 mr-1 mt-1'></i><div>Delete user</div></div>",
          renderer: HandsontableHelper.contextMenuRenderer,
          callback: instance.delUser
        }
      }
    }
  };
};
export default ContextMenu;